<sw-page class="sw-upselling-global-import">
    <template #smart-bar-header>
        <h2>{{ $tc('sw-upselling-global-import.general.mainMenuItemGeneral') }}</h2>
    </template>

    <template #smart-bar-actions>
        <mt-button
            v-if="currentTab === 'export'"
            variant="primary"
            :disabled="!selectedUpselling"
            @click="onExport">
            {{ $tc('sw-upselling-global-import.general.exportButton') }}
        </mt-button>
        
        <mt-button
            v-if="currentTab === 'import'"
            variant="primary"
            :is-loading="isLoading"
            :disabled="!csvFile || isLoading"
            @click="onImport">
            {{ $tc('sw-upselling-global-import.general.importButton') }}
        </mt-button>
    </template>

    <template #content>
        <sw-tabs class="sw-upselling-global-import__tabs" :default-item="currentTab">
            <sw-tabs-item
                name="import"
                :route="{ name: 'sw.upselling.global.import.index.import' }"
                :title="$tc('sw-upselling-global-import.general.importTab')">
                {{ $tc('sw-upselling-global-import.general.importTab') }}
            </sw-tabs-item>
            
            <sw-tabs-item
                name="export"
                :route="{ name: 'sw.upselling.global.import.index.export' }"
                :title="$tc('sw-upselling-global-import.general.exportTab')">
                {{ $tc('sw-upselling-global-import.general.exportTab') }}
            </sw-tabs-item>
        </sw-tabs>

        <sw-card-view>
            <!-- Import Tab -->
            <sw-card v-if="currentTab === 'import'" :title="$tc('sw-upselling-global-import.general.importCardTitle')" :large="true">
                <div v-if="errors.length > 0" class="sw-upselling-import__errors">
                    <sw-alert variant="error" :title="$tc('sw-upselling-global-import.general.importErrors')">
                        <ul>
                            <li v-for="error in errors" :key="error">{{ error }}</li>
                        </ul>
                    </sw-alert>
                </div>

                <div v-if="successMessage" class="sw-upselling-import__success">
                    <sw-alert variant="success" :title="$tc('sw-upselling-global-import.general.importSuccess')">
                        {{ successMessage }}
                    </sw-alert>
                </div>
                
                <sw-file-input
                    :label="$tc('sw-upselling-global-import.general.uploadTitle')"
                    :placeholder="$tc('sw-upselling-global-import.general.uploadPlaceholder')"
                    accept=".csv"
                    @update:value="onFileChange">
                </sw-file-input>
                
                <div class="sw-upselling-import__help-text">
                    <p>{{ $tc('sw-upselling-global-import.general.uploadDescription') }}</p>
                </div>

                <sw-container columns="1fr" gap="20px">
                    <div class="sw-upselling-import__format-info">
                        <h4>{{ $tc('sw-upselling-global-import.general.csvFormatTitle') }}</h4>
                        <div class="sw-upselling-import__format-example">
                            <code>product_sku,crossSell_sku,title,type</code>
                        </div>
                        <p>{{ $tc('sw-upselling-global-import.general.csvFormatDescription') }}</p>
                    </div>
                </sw-container>
            </sw-card>

            <!-- Export Tab -->
            <sw-card v-if="currentTab === 'export'" :title="$tc('sw-upselling-global-import.general.exportCardTitle')" :large="true">
                <div v-if="errors.length > 0" class="sw-upselling-export__errors">
                    <sw-alert variant="error" :title="$tc('sw-upselling-global-import.general.exportErrors')">
                        <ul>
                            <li v-for="error in errors" :key="error">{{ error }}</li>
                        </ul>
                    </sw-alert>
                </div>

                <sw-entity-single-select
                    entity="zeo_product_upselling"
                    v-model:value="selectedUpselling"
                    :label="$tc('sw-upselling-global-import.general.selectUpselling')"
                    :placeholder="$tc('sw-upselling-global-import.general.selectUpsellingPlaceholder')"
                    :criteria="upsellingCriteria"
                    show-clearable-button>
                </sw-entity-single-select>
                
                <div class="sw-upselling-export__description">
                    <p>{{ $tc('sw-upselling-global-import.general.exportDescription') }}</p>
                </div>
            </sw-card>
        </sw-card-view>
    </template>
</sw-page>
